import { render } from "./ExpedicionesEstadoComisiones.vue?vue&type=template&id=45556300&scoped=true"
import script from "./ExpedicionesEstadoComisiones.vue?vue&type=script&lang=ts"
export * from "./ExpedicionesEstadoComisiones.vue?vue&type=script&lang=ts"

import "./ExpedicionesEstadoComisiones.vue?vue&type=style&index=0&id=45556300&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-45556300"

export default script